namespace SolovisGateway.Admin.DataEnvironments {

    export interface AddDataEnvironmentUserDialogOptions {
        dataEnvironmentId: number;

        userAddedCallback: () => void;
    };

    export class AddDataEnvironmentUserDialog {

        private _options: AddDataEnvironmentUserDialogOptions;

        private _formBuilder: Solovis.UI.InputControls.FormBuilder;
        private _dialog: Solovis.UI.Dialog;

        constructor(options: AddDataEnvironmentUserDialogOptions) {
            this._options = options;
        }


        public show() {
            let self = this;

            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: $("<div>")
            });
            this._formBuilder = formBuilder;

            var userAccountDataSource: Solovis.UI.InputControls.FormEditorSimpleDataSource = {
                load: function (loadOptions) {                                        
                    let promise = new Promise(function (resolve, reject) {
                        Solovis.Rpc.invoke(
                            "~/DataEnvironment/SearchVisibleUserAccounts",
                            { filterText: loadOptions.searchValue },
                            function (response, success) {
                                if (success) {
                                    let accountDataList = _.map(response.result.accounts, function (account: any) {
                                        return {
                                            text: account.primaryEmail + " - " + account.fullName,
                                            value: account.primaryEmail
                                        };
                                    });                                    

                                    resolve(accountDataList);
                                }
                                else {
                                    reject(response);
                                }
                            });
                    });

                    return promise;
                },

                byKey: function (key) {
                    let promise = new Promise(function (resolve, reject) {
                        Solovis.Rpc.invoke(
                            "~/DataEnvironment/GetVisibleUserAccount",
                            { primaryEmail: key },
                            function (response, success) {
                                if (success) {
                                    let account = response.result.account;
                                    if (account) {
                                        let accountData = {
                                            text: account.primaryEmail + " - " + account.fullName,
                                            value: account.primaryEmail
                                        };
                                        resolve(accountData);
                                    }
                                    else {
                                        resolve(null);
                                    }
                                }
                                else {
                                    reject(response);
                                }
                            });
                    });

                    return promise;
                }
            };

            formBuilder.addEntry({
                name: "email",
                label: "Email",

                editor: {
                    type: "select",
                    selectOptions: {
                        dataSource: userAccountDataSource,
                        searchEnabled: true,
                        acceptCustomValue: true,
                        createCustomItemCallback: function (text) {              
                            let emailValue = text;
                            if (text) {
                                // Ensure we ignore the info text if this gets reparsed.
                                let splitIndex = text.indexOf(" - ");
                                if (splitIndex >= 0) {
                                    emailValue = text.substr(0, splitIndex);
                                }
                            }

                            return { text: text, value: emailValue };
                        }
                    },
                    required: true
                }
            });

            formBuilder.addEntry({
                name: "isEnvironmentAdmin",
                label: "Environment Admin",

                help: "If checked, user will be given 'System Admin' role in the environment.",

                editor: {
                    type: "bool"
                }
            });


            this._dialog = formBuilder.showAsDialog({
                desiredWidth: 600,
                desiredHeight: 300,
                title: "Add User To Environment",

                showSaveCancel: true,

                saveCallback: function () {
                    self._add();
                    return false;
                },
                saveButtonText: "Add"
            });
        }

        public _add() {
            let self = this;

            let email = this._formBuilder.getValueByName("email");
            let isEnvironmentAdmin = this._formBuilder.getValueByName("isEnvironmentAdmin");

            Solovis.Rpc.invokeAndWait(
                "~/DataEnvironment/AddUser",
                {
                    userToAdd: {
                        dataEnvironmentId: this._options.dataEnvironmentId,
                        email: email,
                        isEnvironmentAdmin: isEnvironmentAdmin
                    }
                },
                function (response, success) {
                    if (success) {
                        var result = response.result;
                        if (result) {
                            if (result && result.modelResult && result.modelResult.userAdded) {
                                if (self._options.userAddedCallback) {
                                    self._options.userAddedCallback();
                                }

                                self._dialog.close();
                            }
                            else {
                                if (response.result.errors) {
                                    self._formBuilder.applyErrors(response.result.errors);
                                }
                            }
                        }
                    }                    
                });
        }
    }

}